// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import CustomSelect from '../../../components/common/inputs/CustomSelect';
import { QInput } from '../../../components/common/inputs/QInput';
import { Controller, useForm } from 'react-hook-form';
import { translate } from '@application/common/helpers/translate';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useSearchParams } from 'react-router-dom';
import { UploadAction } from '@ui/components/common/actions/UploadAction';
import { DownloadAction } from '@ui/components/common/actions/DownloadAction';
export const CompanyDetail = ({ control, errors, trigger }) => {
    const { freelancer } = useAppSelector((state) => state.freelancer);
    const { countriesDropdown } = useAppSelector((state) => state.country);
    const [docEroor, setdocEroor] = useState('');
    const [editFile, setEditFile] = useState(false);
    const [isFileUploaded, setisFileUploaded] = useState(false);
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const { setValue } = useForm({});
    const { setError, clearErrors } = useForm({});
    const handleFileUpload = (file) => {
        const maxFileSize = 16777216;
        const uploadedFile = file;
        setisFileUploaded(true);
        if (uploadedFile) {
            if (!['application/pdf'].includes(uploadedFile.type))
                setError('COCDocument', {
                    message: translate('validations.onlyPDFAllowed')
                });
            else if (uploadedFile.size > maxFileSize) {
                setError('COCDocument', {
                    message: translate('validations.maxAllowedFileSize')
                });
            }
            else {
                setValue('COCDocument', uploadedFile);
                clearErrors('COCDocument');
            }
        }
        else {
            setValue('COCDocument', undefined);
            setisFileUploaded(false);
            clearErrors('COCDocument');
        }
    };
    useEffect(() => {
        if (errors.COCDocument) {
            setdocEroor(errors.COCDocument.message);
        }
    }, [errors.COCDocument]);
    return (_jsxs(_Fragment, { children: [_jsx(Grid, { item: true, xs: 12, sm: 6, md: 6, children: _jsx(Controller, { name: 'companyName', control: control, defaultValue: '', rules: {
                        // required: { value: true, message: translate('validations.fieldIsRequired') },
                        pattern: {
                            value: /^[^!@#]*$/,
                            message: 'Invalid company name'
                        },
                        maxLength: {
                            value: 50,
                            message: translate('validations.maximumCharactersAllowed', { count: 50 })
                        }
                    }, render: ({ field }) => (_jsx(QInput, { fillBackground: false, ...field, placeholder: 'Company name', label: 'Company name', errormsg: errors.companyName ? errors.companyName.message : '' })) }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 6, children: _jsxs(Box, { children: [_jsx(Typography, { variant: 'subtitle2', color: '#141414', mb: '2px', children: translate('account.companyCountry') }), _jsx(Controller, { name: 'companyCountry', control: control, defaultValue: '',
                            // rules={{
                            //     required: { value: true, message: translate('validations.fieldIsRequired') }
                            // }}
                            render: ({ field }) => (_jsx(CustomSelect, { fillBackground: false,
                                // borderRadius={false}
                                options: countriesDropdown, label: translate('account.companyCountry'), selectedOption: field.value, handleChange: (value) => field.onChange(value), errormsg: errors.companyCountry ? errors.companyCountry.message : '' })) })] }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 6, children: _jsx(Controller, { name: 'bankAccountTitle', control: control, defaultValue: '', rules: {
                        // required: { value: true, message: translate('validations.fieldIsRequired') },
                        minLength: {
                            value: 2,
                            message: translate('validations.minimumCharactersAllowed', { count: 2 })
                        },
                        maxLength: {
                            value: 50,
                            message: translate('validations.maximumCharactersAllowed', { count: 50 })
                        },
                        pattern: {
                            value: /^[^!@#]*$/,
                            message: translate('validations.invalidBankAccountTitle')
                        }
                    }, render: ({ field }) => (_jsx(QInput, { fillBackground: false, ...field, placeholder: 'Account holder name', label: 'Account holder name', errormsg: errors.bankAccountTitle ? errors.bankAccountTitle.message : '' })) }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 6, children: _jsx(Controller, { name: 'vat', control: control, defaultValue: undefined, rules: {
                        // required: { value: true, message: translate('validations.fieldIsRequired') },
                        maxLength: {
                            value: 20,
                            message: translate('validations.maximumCharactersAllowed', { count: 20 })
                        }
                    }, render: ({ field }) => (_jsx(QInput, { ...field, fillBackground: false, placeholder: 'BTW number', label: 'BTW number', errormsg: errors.vat ? errors.vat.message : '' })) }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 6, children: _jsx(Controller, { name: 'companyAddress', control: control, defaultValue: '', rules: {
                        // required: { value: true, message: translate('validations.fieldIsRequired') },
                        pattern: {
                            value: /^[^!@#]*$/,
                            message: 'Invalid company address'
                        },
                        maxLength: {
                            value: 40,
                            message: translate('validations.maximumCharactersAllowed', { count: 40 })
                        }
                    }, render: ({ field }) => (_jsx(QInput, { fillBackground: false, ...field, placeholder: 'Street name 10', label: 'Business address', errormsg: errors.companyAddress ? errors.companyAddress.message : '' })) }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 6, children: _jsx(Controller, { name: 'bankAccountNumber', control: control, defaultValue: undefined, rules: {
                        // required: { value: true, message: translate('validations.fieldIsRequired') },
                        maxLength: {
                            value: 20,
                            message: translate('validations.maximumCharactersAllowed', { count: 20 })
                        }
                    }, render: ({ field }) => (_jsx(QInput, { ...field, fillBackground: false, placeholder: 'Bank account number', label: 'Bank account number', errormsg: errors.bankAccountNumber ? errors.bankAccountNumber.message : '' })) }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 6, children: _jsx(Controller, { name: 'companyZipCode', control: control, defaultValue: '', rules: {
                        // required: { value: true, message: translate('validations.fieldIsRequired') },
                        maxLength: {
                            value: 10,
                            message: translate('validations.maximumCharactersAllowed', { count: 10 })
                        }
                    }, render: ({ field }) => (_jsx(QInput, { fillBackground: false, ...field, placeholder: '1234 AA', label: 'Postal code', errormsg: errors.companyZipCode ? errors.companyZipCode.message : '' })) }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 6, children: _jsx(Box, { mt: 2.75, children: editFile || !freelancer.document ? (_jsx(Controller, { name: 'COCDocument', control: control, defaultValue: null, rules: {
                            //   required: { value: true, message: translate('validations.fieldIsRequired') },
                            validate: {
                                fileType: (file) => {
                                    if (file && !['application/pdf'].includes(file.type)) {
                                        return translate('validations.onlyPDFAllowed');
                                    }
                                    return true;
                                },
                                fileSize: (file) => {
                                    if (file && file.size > 16777216) {
                                        return translate('validations.maxAllowedFileSize');
                                    }
                                    return true;
                                }
                            }
                        }, render: ({ field }) => (_jsx(UploadAction, { onFileUpload: (file) => {
                                field.onChange(file);
                                handleFileUpload(file);
                            }, text: 'Upload KvK document (not older than 3 months)', variant: isFileUploaded ? 'outLined' : 'contained', h: isFileUploaded ? 55 : 55, borderRadius: '13px', py: isFileUploaded ? 0 : 0, titleFont: '12px', errorBottom: -25, actionHeight: 70, subtitleFont: '8px', px: isFileUploaded ? 0 : 16, direction: 'col', errormsg: errors.COCDocument ? errors.COCDocument.message : '' })) })) : (freelancer.document && (_jsx(DownloadAction, { fileName: freelancer.document.name, width: '100%', type: 'upload', clear: () => setEditFile(true) }))) }) }), _jsx(Grid, { item: true, xs: 12, sm: 6, md: 6, children: _jsx(Controller, { name: 'KVK', control: control, defaultValue: '', rules: {
                        // required: { value: true, message: translate('validations.fieldIsRequired') },
                        maxLength: {
                            value: 20,
                            message: translate('validations.maximumCharactersAllowed', { count: 20 })
                        }
                    }, render: ({ field }) => (_jsx(QInput, { ...field, fillBackground: false, placeholder: 'KVK', label: 'KVK', errormsg: errors.KVK ? errors.KVK.message : '' })) }) })] }));
};
